// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"c76dad34","239":"52615c84","977":"b515260a"}[chunkId] + ".chunk.js";
};